import { InfoIcon } from './ui'

/** Info callout on claim review screens for customers who need extra support. */
export default function ClaimAdditionalSupportNotice() {
  return (
    <div className="flex w-full max-w-[768px] gap-[12px] rounded-xl border border-border-primary bg-background-primary p-[16px] shadow-xs">
      <InfoIcon className="size-5 shrink-0 text-text-tertiary-600" aria-hidden />
      <div className="flex min-w-0 flex-1 flex-col gap-[6px]">
        <p className="m-0 font-body font-semibold text-sm leading-sm text-text-primary-900">
          Need additional support?
        </p>
        <p className="m-0 font-body text-sm leading-sm text-text-secondary-700">
          We recognise that everyone&apos;s situation is different. If you&apos;re suffering from financial
          hardship, family or domestic violence or experiencing any other vulnerability and require
          additional support, call us on{' '}
          <a href="tel:1300296296" className="font-semibold text-background-brand-solid underline underline-offset-2">
            1300 296 296
          </a>
          .
        </p>
      </div>
    </div>
  )
}
